/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ResourcesInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Past Elections Results"
              description={
                <>

                  <h4>General Election</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/GeneralElection_42nd">42nd PGE (November 26, 2024)</a></u></li> <br />
                    <li><u><a href="/GeneralElection_41st">41st PGE (August 17, 2021)</a></u></li> <br />
                    <li><u><a href="/GeneralElection_40th">40th PGE (May 30, 2017)</a></u></li> <br />
                  </ul>
                  <br />
                  <h4>By-Election</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/PictouWestByElection">Pictou West By-Election (May 21, 2024)</a></u></li>
                  </ul>
                  {/* <br />
                  <h4><a href="/ElectoralFinanceCandidateReportingRequirements"><u>Electoral Finance Candidate Reporting Requirements</u></a></h4>
                  <br />
                  <h4><a href="https://electionsns.maps.arcgis.com/apps/dashboards/2c7c602a6a8f4837ae80f362e0fd2a55"><u>Electoral District Profiles</u></a></h4> */}

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ResourcesInformation;
